<template>
    <div class="col-6 mb--md">
        <button type="button" @click="usePowerUp" :disabled="disabled || ! powerUp.quantity" class="btn btn--sm btn--block btn--white btn--left-icon-circle">
            <slot>
                {{ powerUp.name }}
            </slot>
        </button>
    </div>
</template>

<script>
export default {
    props: {
        powerUp: Object,
        disabled: {
            default: false,
        },
    },

    methods: {
        usePowerUp() {
            Quiz.$emit('use_power_up', this.powerUp)
        }
    },
}
</script>